/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { useStore } from 'src/onboarding/store/store';
import Analytics from '@web-solutions/module-analytics';
import { useCalorieCalculation } from 'src/onboarding/hooks/useCalculateCalories';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const gender = useStore((state) => state.gender);

  const calculateCalories = useCalorieCalculation();
  const calories = calculateCalories();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{t('onboarding.calorieNeeds.title')} {calories} kcal</Title>
        <Text semibold className={styles.description}>
          {t('onboarding.calorieNeeds.subTitle')}
        </Text>
      </div>
      <div className={styles.continue}>
        <div className={styles.blur}></div>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'calorie-needs',
            });
            onNext();
          }}
          title={t('onboarding.noMoreCravings.continue')}
        />
      </div>
    </div>
  );
}

export default Page;
